module.exports = __webpack_public_path__ + "static/North-West-Corner-Part-Aerial-View-Image-5d336ac55b32d8deb91f0ba153d55326.jpg";